export const ADMIN_STATUS = {
  ACTIVE: 'ACTIVE',
  UNVERIFIED: 'UNVERIFIED',
} as const;
export type AdminStatus = typeof ADMIN_STATUS[keyof typeof ADMIN_STATUS];

export const ADMIN_ROLE = {
  SUPER: 'SUPER',
  SUB: 'SUB',
} as const;
export type AdminRole = typeof ADMIN_ROLE[keyof typeof ADMIN_ROLE];

export const ADMIN_STATUS_JA_LABEL: Record<AdminStatus, string> = {
  ACTIVE: '有効',
  UNVERIFIED: '未確認',
};
